var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsologo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 113,
    viewBox: "0 0 71 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8533 47.9059C23.6802 47.9059 12.9727 37.1983 12.9727 24.0253C12.9727 10.8522 23.6802 0.0742188 36.8533 0.0742188C50.0263 0.0742188 60.7338 10.7817 60.7338 23.9548C60.7338 37.1279 50.0263 47.9059 36.8533 47.9059ZM36.8533 13.7404C31.2177 13.7404 26.6388 18.3193 26.6388 23.9548C26.6388 29.5904 31.2177 34.1692 36.8533 34.1692C42.4888 34.1692 47.0677 29.5904 47.0677 23.9548C47.0677 18.3193 42.4888 13.7404 36.8533 13.7404Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4095 112.785L39.6713 78.197C37.7693 82.5646 35.3038 86.6503 32.2747 90.3839C24.9485 99.2599 14.734 105.6 3.39251 108.206L0.292969 94.8923C8.53495 92.9903 16.002 88.341 21.3558 81.8601C26.8504 75.1679 29.8091 66.9964 29.8091 58.3317L42.9117 55.0913L70.7372 106.304L58.4095 112.785Z",
    fill: "#3098F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsologo);
export default __webpack_public_path__ + "static/media/isologo.feaf29487bdd6fc28847d6f013c70921.svg";
export { ForwardRef as ReactComponent };